import { motion } from "framer-motion";

/**
 * Renders a heading where each line-of-words animates from below a mask.
 * lines: array of strings (each string is one visual line).
 */
export default function MaskedLines({ lines, className = "", delay = 0.15, stagger = 0.09, as: Tag = "h1" }) {
  return (
    <Tag className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask block leading-[1.02]">
          <motion.span
            className="inline-block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.15,
              delay: delay + i * stagger,
              ease: [0.76, 0, 0.24, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
